import React from 'react'
import { SelectedFeatureProvider } from './SelectedFeatureContext'
import { LoaderProvider } from './LoaderContext'
import { AlertProvider } from './AlertContext'
import { ModalProvider } from './ModalContext'
import AlertMessage from '../components/AlertMessage'
import { UserProvider } from './UserContext'



export default function wrapContexts(props) {
    return (
        <>
            <LoaderProvider>
            <UserProvider>
                <AlertProvider>
                    <AlertMessage />
                    <ModalProvider>
                    <SelectedFeatureProvider>
                        {props.children}
                    </SelectedFeatureProvider>
                    </ModalProvider>
                </AlertProvider>
                </UserProvider>
            </LoaderProvider>

        </>
    )
}
